import { __awaiter, __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { Router } from "@angular/router";
import { LocationStrategy } from "@angular/common";
import { ComponentService } from "../../../services/component.service";
import { SharedHttp } from "../../../services/http-client.service";
import { document } from "ngx-bootstrap";
import { AuthenticationWalletModalComponent } from "../authentication-wallet-modal/authentication-wallet-modal.component";
/**
 * Coin Fiat Wallet Modal Component
 */
let ResetWalletPasswordModalComponent = class ResetWalletPasswordModalComponent {
    constructor(sanitizer, httpClient, router, location, compService, themeService) {
        this.sanitizer = sanitizer;
        this.httpClient = httpClient;
        this.router = router;
        this.location = location;
        this.compService = compService;
        this.themeService = themeService;
        this.secondColor = '';
        this.accentColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.errorColor = '';
        this.walletPassword = '';
        this.confirmedWalletPassword = '';
        this.resetButtonDisabled = true;
        this.validPassword = false;
        this.validConfirmPassword = false;
        this.passRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,64}$/;
        this.resetButtonClicked = false;
        this.validMfa = true;
        this.code = [];
        this.validCode = true;
        this.errorMessage = '';
        this.validToken = false;
        this.showNewWalletPassword = false;
        this.showNewWalletPasswordAgain = false;
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.data.step == 3) {
                yield this.httpClient.get('user/resetpasswordconfirm/' + this.data.token).subscribe((data) => {
                    this.validToken = true;
                }, (error) => {
                    this.validToken = false;
                });
            }
        });
    }
    close() {
        this.modal.destroy();
    }
    forgotPassword() {
        this.data.step = 2;
        this.httpClient.post('wallet/forgotpassphrase', { fromWallet: true }).subscribe();
    }
    checkValidation() {
        if (this.passRegex.test(this.walletPassword)) {
            this.validPassword = true;
        }
        else {
            this.validPassword = false;
            this.resetButtonDisabled = true;
            return;
        }
        if (this.walletPassword === this.confirmedWalletPassword) {
            this.validConfirmPassword = true;
        }
        else {
            this.validConfirmPassword = false;
            this.resetButtonDisabled = true;
            return;
        }
        if (this.walletPassword !== '' && this.confirmedWalletPassword !== '') {
            this.resetButtonDisabled = false;
        }
    }
    checkMFAValidation(event, mfaInputId) {
        this.mfaCode = '';
        if (!this.code[0] && !this.code[1] && !this.code[2] && !this.code[3] && !this.code[4] && !this.code[5]) {
            document.getElementById(0).focus();
            return;
        }
        if (event.keyCode === 8) {
            if (mfaInputId > 0) {
                document.getElementById(mfaInputId - 1).focus();
                document.getElementById(mfaInputId - 1).select();
            }
        }
        else {
            if (mfaInputId < 5) {
                document.getElementById(mfaInputId + 1).focus();
            }
        }
        if (this.code.length < 6) {
            return;
        }
        let i = 0;
        for (i; i < this.code.length; i++) {
            if (this.code[i] === '') {
                this.validCode = true;
                this.validMfa = true;
                return;
            }
            else {
                this.mfaCode += this.code[i];
            }
        }
        if (event.keyCode === 13) {
            this.resetPassword();
        }
    }
    resetPassword() {
        if (this.resetButtonDisabled || this.mfaCode.length !== 6) {
            return;
        }
        this.resetButtonClicked = true;
        this.errorMessage = '';
        const passphraseData = {
            passphrase: this.walletPassword,
            passphraseConfirmed: this.confirmedWalletPassword,
            token: this.data.token,
        };
        this.httpClient.get('mfa/checkmfacode?mfa_code=' + this.mfaCode).subscribe((data) => {
            this.validMfa = data['isValid'];
            this.validCode = data['isValid'];
            if (this.validMfa) {
                this.httpClient.post('wallet/resetpassphrase', passphraseData).subscribe((data) => {
                    this.close();
                    this.router.navigateByUrl('wallet/cryptocurrencies');
                    this.compService.openModal(AuthenticationWalletModalComponent, {
                        authenticated: true,
                        type: 'wallet_passphrase_reset',
                        isSuccess: true
                    });
                }, (error) => {
                    this.resetButtonClicked = false;
                    this.errorMessage = error.error['message'];
                });
            }
            else {
                this.resetButtonClicked = false;
            }
        });
    }
};
ResetWalletPasswordModalComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: SharedHttp },
    { type: Router },
    { type: LocationStrategy },
    { type: ComponentService },
    { type: WebsiteThemeService }
];
ResetWalletPasswordModalComponent = __decorate([
    Component({
        selector: 'ecd-reset-wallet-password-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./reset-wallet-password-modal.component.html")).default
    })
], ResetWalletPasswordModalComponent);
export { ResetWalletPasswordModalComponent };
